import { forwardRef, type ReactNode, type HTMLAttributes } from 'react';
import { useTheme } from '@vitness/theme';

export interface IconBoxProps extends HTMLAttributes<HTMLDivElement> {
  icon: ReactNode;
  size?: number;
}

export const IconBox = forwardRef<HTMLDivElement, IconBoxProps>(function IconBox(
  { icon, size = 30, style, ...props },
  ref,
) {
  const { accentRgb } = useTheme();
  const rs = `${accentRgb.r},${accentRgb.g},${accentRgb.b}`;

  return (
    <div
      ref={ref}
      style={{
        width: size,
        height: size,
        borderRadius: 6,
        background: `rgba(${rs},0.07)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      {...props}
    >
      {icon}
    </div>
  );
});
